import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const useAdminUsers = (t) => {
  const [users, setUsers] = useState(null);

  useEffect(() => {
    api.get("/admin/users").then((r) => setUsers(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  const setStatus = useCallback(async (id, status) => {
    try {
      await api.patch(`/admin/users/${id}/status`, { status });
      setUsers((p) => p.map((u) => (u.id === id ? { ...u, status } : u)));
      toast.success(t("status_updated"));
    } catch (e) {
      toast.error(formatApiError(e));
    }
  }, [t]);

  const remove = useCallback(async (id) => {
    try {
      await api.delete(`/admin/users/${id}`);
      setUsers((p) => p.filter((u) => u.id !== id));
      toast.success(t("deleted"));
    } catch (e) {
      toast.error(formatApiError(e));
    }
  }, [t]);

  return { users, setStatus, remove };
};
